<template>
  <div>
    <b-row>
      <b-col>
        <vs-card>
          <b-row>
            <b-col cols="4">
              <b-form-input
                v-model="arananDeger"
                @keyup.enter="smsTopluListe"
                id="smallInput"
                placeholder="Arama..."
              />
            </b-col>

            <b-col cols="2">
              <vs-button
                style="border-radius: 5px"
                @click="faturaCikti()"
                type="gradient"
                >Ara</vs-button
              >
            </b-col>
          </b-row>
        </vs-card>
      </b-col>
    </b-row>
    <ag-grid-vue
      style="width: 100%; height: 400px; margin-top: 25px"
      class="ag-theme-alpine"
      :defaultColDef="defaultColDef"
      :columnDefs="columnDefs"
      :rowData="listSonFaturalar"
      :localeText="localeText"
      @grid-ready="onGridReady"
      @first-data-rendered="onFirstDataRendered"
      :rowSelection="rowSelection"
    >
    </ag-grid-vue>
    <iframe
      width="560"
      height="315"
      id="ciktiPdf2"
      src=""
      frameborder="0"
    ></iframe>
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";

import state from "../../store/state";
import Store from "../../store/store";
import FaturaCiktisiButon2 from "../components/uzum-components/pazaryeri-components/FaturaCiktisiButon2.vue";
import EBelgeButon from "../components/uzum-components/pazaryeri-components/EBelgeButon.vue";
import SmsButon from "../components/uzum-components/pazaryeri-components/SmsButon.vue";

export default {
  data() {
    return {
      rowSelection: null,
      localeText: null,
      columnDefs: null,
      listSonFaturalar: [],
      defaultColDef: {
        sortable: true,
        resizable: true,
      },
      arananDeger: "",
    };
  },
  methods: {
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    faturaCikti() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        orderNumber: vm.arananDeger,
        EMPLOYEEID: Store.state.plasiyer,
      };

      console.log(args);
      soap.createClient(url, function (err, client) {
        client.smsFaturaListele(args, function (err, result) {
          if (result.smsFaturaListeleResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          } else {
            vm.veriler = JSON.parse(result.smsFaturaListeleResult);
            vm.listSonFaturalar = vm.veriler.jsonData;
            console.log(vm.listSonFaturalar);
          }
        });
      });
    },
  },
  components: { AgGridVue, FaturaCiktisiButon2, EBelgeButon, SmsButon },
  created() {
    this.faturaCikti();
    this.rowSelection = "single";
    this.localeText = this.$store.state.uzum.AG_GRID_LOCALE_EN;
  },

  beforeMount() {
    this.columnDefs = [
      {
        headerName: "Sipariş No",
        field: "orderNumber",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Müşteri Ad Soyad",
        sortable: true,
        filter: "agTextColumnFilter",
        valueGetter: fullNameGetter,
        field: "Column1&invoiceFirstName&shipLastName",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Mağaza Kodu",
        sortable: true,
        filter: "agTextColumnFilter",
        field: "magazaKodu",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Telefon Numarası",
        sortable: true,
        filter: "agTextColumnFilter",
        field: "telNo",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        width: 130,
        field: "",
        cellRendererFramework: "SmsButon",
        headerName: "Mesaj Gönder",
      },
      {
        width: 120,
        field: "",
        cellRendererFramework: "FaturaCiktisiButon2",
        headerName: "Tekrar Yazdır",
        autoHeight: true,
      },
      {
        width: 100,
        field: "",
        cellRendererFramework: "EBelgeButon",
        headerName: "E Belge",
      },
    ];
  },
};
function fullNameGetter(params) {
  if (typeof params.data.Column1 == "undefined") {
    params.data.Column1 = "";
  }
  if (typeof params.data.shipFirstName == "undefined") {
    params.data.shipFirstName = "";
  }
  if (typeof params.data.shipLastName == "undefined") {
    params.data.shipLastName = "";
  }
  return (
    params.data.Column1 +
    " " +
    params.data.shipFirstName +
    " " +
    params.data.shipLastName
  );
}
</script>